import { Action } from "../../../actions/actions";
import { HomeActionTypes } from "../actions/actionTypes";
import { SubAppConfig } from "../../../reducers/subAppsConfig.reducer";

export function selectedSubApp(
    state: SubAppConfig = null,
    action: Action
): SubAppConfig {
    switch (action.type) {
        case HomeActionTypes.UPDATE_ACTIVE_SUBAPPS:
            return state;
        case HomeActionTypes.SELECT_SUBAPP:
            return action.payload;
        default:
            return state;
    }
}
